import { render, staticRenderFns } from "./fixo.vue?vue&type=template&id=3aae8ec6&scoped=true&"
import script from "./fixo.vue?vue&type=script&lang=js&"
export * from "./fixo.vue?vue&type=script&lang=js&"
import style0 from "./fixo.vue?vue&type=style&index=0&id=3aae8ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae8ec6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VImg,VRow,VTextField})
